module.exports = __webpack_public_path__ + "static/img/ActPoster_zhipin_main.f79f1e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/active1017/ActPoster_zhipin_main.png
// module id = wtTf
// module chunks = 0